import { useLang } from "@/lib/lang";
import { LegalLayout, Section, BulletList } from "@/components/LegalLayout";

export default function About() {
  const { lang } = useLang();
  const T = lang === "fr" ? FR : EN;

  return (
    <LegalLayout title={T.title}>
      <h1 className="font-serif-mystery text-4xl md:text-5xl text-zinc-900 mb-2" data-testid="about-title">{T.title}</h1>
      <p className="font-mono-data text-xs uppercase tracking-widest text-[#8b6f3d] mb-8">Treasure Hunt · Legends · UFOs · And More</p>

      <p className="text-zinc-700 leading-relaxed mb-6 text-lg">{T.intro1}</p>
      <p className="text-zinc-700 leading-relaxed mb-6">{T.intro2}</p>
      <p className="text-zinc-700 leading-relaxed mb-8">{T.intro3}</p>

      <Section title={T.vision.title}>
        <p>{T.vision.p1}</p>
        <p>{T.vision.p2}</p>
        <p>{T.vision.p3}</p>
      </Section>

      <Section title={T.contact.title}>
        <p>{T.contact.body}</p>
        <BulletList items={T.contact.items} />
        <p className="pt-2 font-mono-data text-sm"><span className="text-zinc-500">{T.contact.emailLabel} :</span> <a href="mailto:BLEUREEFOBERMAYR@GMAIL.COM" className="text-[#8b6f3d] hover:underline">BLEUREEFOBERMAYR@GMAIL.COM</a></p>
      </Section>
    </LegalLayout>
  );
}

const FR = {
  title: "À propos de nous",
  intro1: "The Only Map You Will Ever Need est une carte interactive créée pour les passionnés d'exploration, d'histoire et de mystères.",
  intro2: "Notre objectif est de rassembler au même endroit des informations fascinantes sur les merveilles du monde, les civilisations anciennes, les trésors perdus, les épaves, les légendes locales, les phénomènes mystérieux et les histoires qui alimentent l'imagination.",
  intro3: "Notre plateforme mélange découverte, culture, exploration et technologie afin d'offrir une nouvelle façon de parcourir le monde.",
  vision: {
    title: "Notre vision",
    p1: "Nous croyons que chaque endroit possède une histoire.",
    p2: "Certaines histoires sont prouvées par l'histoire et l'archéologie, tandis que d'autres appartiennent aux légendes et aux récits transmis au fil du temps.",
    p3: "Notre mission est de créer une carte mondiale où les curieux peuvent apprendre, explorer et découvrir de nouveaux mystères.",
  },
  contact: { title: "Contact", body: "Vous pouvez nous contacter pour :", emailLabel: "Courriel",
             items: ["Questions générales.", "Suggestions de nouveaux lieux.", "Corrections d'informations.", "Partenariats."] },
};

const EN = {
  title: "About Us",
  intro1: "The Only Map You Will Ever Need is an interactive map created for enthusiasts of exploration, history and mysteries.",
  intro2: "Our goal is to gather in one place fascinating information about the world's wonders, ancient civilizations, lost treasures, shipwrecks, local legends, mysterious phenomena and stories that fuel imagination.",
  intro3: "Our platform blends discovery, culture, exploration and technology to offer a new way to travel the world.",
  vision: {
    title: "Our vision",
    p1: "We believe that every place has a story.",
    p2: "Some stories are proven by history and archaeology, while others belong to legends and tales passed down over time.",
    p3: "Our mission is to create a worldwide map where curious minds can learn, explore and discover new mysteries.",
  },
  contact: { title: "Contact", body: "You can reach us for:", emailLabel: "Email",
             items: ["General questions.", "Suggestions for new places.", "Information corrections.", "Partnerships."] },
};
